import { createApiClient, ApiError } from '@academia-apolo/shared-client';
import { API_BASE_URL } from './constants';
import { getStoredTokens, storeAuth, clearAuth } from './auth';
export const apiClient = createApiClient({
    baseUrl: API_BASE_URL,
    getTokens: () => getStoredTokens(),
    setAuth: (tokens, user) => storeAuth(tokens, user),
    clearAuth: () => clearAuth(),
    onUnauthenticated: () => {
        window.location.href = '/login';
    },
});
/**
 * Fetches a binary endpoint and returns the response Blob with the resolved
 * Content-Type. Bypasses the JSON envelope so it works for endpoints that
 * stream raw bytes (PDFs, etc.). Authenticated via the same JWT as apiClient.
 */
export async function fetchAuthBlob(endpoint) {
    const tokens = getStoredTokens();
    const res = await fetch(`${API_BASE_URL}${endpoint}`, {
        headers: tokens?.accessToken ? { Authorization: `Bearer ${tokens.accessToken}` } : {},
    });
    if (res.status === 401) {
        clearAuth();
        window.location.href = '/login';
        throw new ApiError('AUTH_SESSION_EXPIRED', 'Sesión expirada', 401);
    }
    if (!res.ok) {
        let body = {};
        try {
            body = (await res.json());
        }
        catch {
            // ignore — non-JSON body
        }
        throw new ApiError(body.error?.code ?? 'INTERNAL_ERROR', body.error?.message ?? 'Error al descargar el archivo', res.status);
    }
    const blob = await res.blob();
    const contentType = res.headers.get('content-type') ?? 'application/octet-stream';
    const cd = res.headers.get('content-disposition') ?? '';
    const match = cd.match(/filename\*=UTF-8''([^;]+)/i) ?? cd.match(/filename="([^"]+)"/i);
    const fileName = match?.[1] ? decodeURIComponent(match[1]) : null;
    return { blob, contentType, fileName };
}
export { ApiError };
//# sourceMappingURL=api-client.js.map